import { gql } from '@apollo/client';

export const GET_PROCTOR_LIST = gql`
  query getProctorList {
    auth_user(where: { roles: { role: { _eq: PROCTOR } } }) {
      id
      name
      email
    }
  }
`;
